
<div *ngIf="!isWorkflowMandatory">
    <div *ngIf="getIsFinalSubmission()" class="alert alert-dismissable" role="alert">
        <i class="text-info icon-info"></i>
        {{'CardSendWorkflow.FoundErrors' | translate}}&nbsp;
        <a [routerLink]="" (click)="changeRevisionNeeded()" style="cursor:pointer">{{'CardSendWorkflow.FoundErrorsClick' | translate}}</a>
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
            <span aria-hidden="true" class="icon-close"></span>
        </button>
    </div>

    <div *ngIf="getIsRevision() && !this.workflow.isReturn" class="alert alert-dismissable" role="alert">
        <i class="text-info icon-info"></i>
        {{'CardSendWorkflow.FoundNoErros' | translate}}&nbsp;
        <a [routerLink]="" (click)="changeRevisionNeeded()" style="cursor:pointer">{{'CardSendWorkflow.FoundNoErrosClick' | translate}}</a>
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
            <span aria-hidden="true" class="icon-close"></span>
        </button>
    </div>
</div>

<div class="content-send text-center">
  <div class="icons text-primary">
    <span *ngIf="getIsRevision()" class="icon-reload"></span>
    <span *ngIf="getIsFinalSubmission() || getIsSubmitToSubscriber()" class="icon-loading"></span>
  </div>
  <div class="mb-4">
    <h5 class="text-gray-700" *ngIf="getIsFinalSubmission()">{{(workflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 ? 'CardSendWorkflow.SubmitFinal' : 'CardSendWorkflow.SubmitFinalCT') | translate}}</h5>
    <h5 class="text-gray-700" *ngIf="getIsSubmitToSubscriber()">{{(workflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 ? 'CardSendWorkflow.SubmitToSubscriber' : 'CardSendWorkflow.SubmitToSubscriberCT' ) | translate}}<br>{{'CardSendWorkflow.SubmitToSubscriber2' | translate}}</h5>
    <h5 class="text-gray-700" *ngIf="getIsRevision()" style="white-space: pre-line">{{(workflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 ? 'CardSendWorkflow.Revision' : 'CardSendWorkflow.RevisionCT') | translate}}</h5>
  </div>
</div>

<div class="mb-4">
    <div class="col-xs-12">
        <div *ngIf="getIsRevision()" class="col-sm-12">
            <div class="form-group">
                <!-- File observations-->
                <label for="RevisionReason"><span class="mandatory">*</span>{{'CardSendWorkflow.RevisionReason' | translate}}</label>
                <textarea class="form-control" type="text" [(ngModel)]="cardData.revisionReason" #revisionReason="ngModel" name="revisionReason" required maxlength="3000"></textarea>
                <validation-message [control]="revisionReason"></validation-message>
            </div>
        </div>
    </div>
</div>
